import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { diyLoanStatusPageViewed } from "../post-inspection-diy-loan-details/tracking";

const PostInspectionDiyLoanStatus = ({
    isOpenLoan,
    updateAllowed,
    handleChange,
    callGaHandler = () => {}
}) => {

    useEffect(() => {
        callGaHandler(diyLoanStatusPageViewed);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div styleName={"styles.loanDetailsSection"}>
            <h2>Share your loan details</h2>
            <p styleName={"styles.text"}>You need to share your car loan information for further process</p>
            <div styleName={"styles.loanStatus"}>
                <h4>Car loan status</h4>
                <div styleName={"styles.toggleCta"}>
                    <h5 styleName={`${isOpenLoan ? "" : "styles.active"} ${!updateAllowed && !isOpenLoan ? "styles.disabled" : ""}`}>CLOSED</h5>
                    <label styleName={"styles.switch"}>
                        <input disabled={!updateAllowed} type="checkbox" onChange={handleChange} checked={isOpenLoan} />
                        <span styleName={`styles.slider ${updateAllowed ? "" : "styles.disabledToggle"}`} />
                    </label>
                    <h5 styleName={`${isOpenLoan ? "styles.active" : ""} ${!updateAllowed && isOpenLoan ? "styles.disabled" : ""}`}>OPEN</h5>
                </div>
            </div>
        </div>
    );
};

PostInspectionDiyLoanStatus.propTypes = {
    handleChange: PropTypes.func,
    updateAllowed: PropTypes.bool,
    isOpenLoan: PropTypes.bool,
    callGaHandler: PropTypes.func
};
export default PostInspectionDiyLoanStatus;
